import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import { isDependencyConnector } from '../objects/guards';
import trackEvent from '../utils/analytics';

class ToolRemoveDependencyLines extends Tool {
  static toolName = 'Remove dependency lines';

  static available({ controller }: IToolAvailableInput) {
    const canvasObjects = controller.canvas.getObjects();
    return (
      controller.allowRecordLinking() &&
      canvasObjects.some(isDependencyConnector)
    );
  }

  static enabled({ controller }: IToolEnabledInput) {
    return ToolRemoveDependencyLines.available({ controller });
  }

  static action({ controller }: IToolActionInput) {
    controller.dependencyLineManager.deleteDependencyLines();
    trackEvent(
      'Feature-7229119605601784574',
      'User removes whiteboard dependency lines'
    );
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolRemoveDependencyLines,
      'fa-regular fa-arrows-turn-to-dots'
    );
  }
}

export default ToolRemoveDependencyLines;
